import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import './Home.css';
import backgroundImage from '../assets/background.png';
import logo from '../assets/logo.png';

const Home = () => {
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      console.log('Fetching featured products from:', `${process.env.REACT_APP_API_URL}/api/products/featured`);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/products/featured`);
      console.log('Featured products response:', response.data);
      console.log('Featured products length:', response.data.length);
      
      if (response.data && response.data.length > 0) {
        console.log('Using featured products');
        setProducts(response.data);
      } else {
        console.log('No featured products, using fallback');
        // Fallback to latest 3 products by updatedAt if no featured products
        const fallbackResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/products`);
        const sortedProducts = fallbackResponse.data
          .sort((a, b) => new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0))
          .slice(0, 3);
        setProducts(sortedProducts);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setProducts([
        { id: 1, name: 'Muruku (Spicy)', description: 'Traditional crispy Indian snack with authentic spices', category: 'Muruku', price: 8.50, stockStatus: true },
        { id: 2, name: 'Masala Peanuts', description: 'Crunchy peanuts coated with aromatic spice blend', category: 'Peanuts', price: 6.80, stockStatus: true },
        { id: 3, name: 'Traditional Sweets', description: 'Handmade Indian sweets for special occasions', category: 'Sweets', price: 12.00, stockStatus: true }
      ]);
    }
  };

  return (
    <div className="container">
      <main>
        <section className="hero">
        <div>
          <h1 style={{ color: 'white' }}>Star Tidbits — Premium Indian Snacks in Singapore</h1>
          <p style={{ color: 'white' }}>Leading manufacturer and retailer of authentic muruku, savories, peanuts, and Indian sweets. Serving both retail customers and wholesale partners across Singapore since 1998.</p>
          <div style={{ display: 'flex', gap: '12px' }}>
            <Link className="btn" to="/products">Shop Now</Link>
            <Link className="secondary" to="/contact" style={{ color: 'white' }}>Contact Us</Link>
          </div>

          <div className="pill-row">
            <div className="pill"><strong>Since 1998</strong><div style={{ marginLeft: '8px', color: '#666' }}>25+ Years Experience</div></div>
            <div className="pill"><strong>Location</strong><div style={{ marginLeft: '8px', color: '#666' }}>Bukit Batok Crescent</div></div>
            <div className="pill"><strong>Service</strong><div style={{ marginLeft: '8px', color: '#666' }}>Retail & Wholesale</div></div>
          </div>
        </div>

        <div>
            </div>
      </section>

      <section id="products">
        <h2 style={{ marginTop: '28px' }}>Featured Products</h2>
        <div className="grid grid-3">
          {products.map(product => (
            <div key={product.id} className="card" style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', height: '100%' }}>
              {product.image && (
                <img src={product.image} alt={product.name} style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem' }} />
              )}
              <h3>{product.name}</h3>
              <p style={{ color: 'var(--neutral-dark)', opacity: 0.8, marginBottom: '1rem' }}>
                {product.description ? product.description.substring(0, 50) + '...' : 'Premium quality snack'}
              </p>
              
              <div style={{ marginBottom: '1rem' }}>
                <span className="badge" style={{ backgroundColor: '#e3f2fd', color: '#1976d2', padding: '0.25rem 0.5rem', borderRadius: '4px', fontSize: '0.75rem' }}>
                  {product.category}
                </span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <div>
                  <div style={{ fontSize: '1.25rem', fontWeight: '600', color: 'var(--primary-saffron)' }}>
                    S${product.price ? product.price.toFixed(2) : '0.00'}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: 'var(--accent-green)' }}>
                    In Stock
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '0.5rem', marginTop: 'auto' }}>
                <button 
                  className="btn btn-outline" 
                  style={{ flex: 1, fontSize: '0.875rem' }}
                  onClick={() => {
                    setSelectedProduct(product);
                    setShowModal(true);
                  }}
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section id="services" style={{ marginTop: '28px' }}>
        <h2>Our Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <h3>Retail Supply</h3>
            <p>Supplying 35+ types of tidbits to major supermarkets and retail shops across Singapore.</p>
          </div>
          <div className="service-card">
            <h3>Festival Orders</h3>
            <p>Traditional Indian sweets and Muruku for Diwali, Tamil New Year, and other festivals.</p>
          </div>
          <div className="service-card">
            <h3>Event Catering</h3>
            <p>Special occasion supply for open houses, temple functions, weddings, and company parties.</p>
          </div>
          <div className="service-card">
            <h3>Quality Assurance</h3>
            <p>Proper hygiene and quality standards maintained from preparation to dispatch.</p>
          </div>
          <div className="service-card">
            <h3>24-Hour Service</h3>
            <p>Round-the-clock customer service with email ordering available.</p>
          </div>
          <div className="service-card">
            <h3>Shipping & Pickup</h3>
            <p>Enjoy FREE Shipping on Orders Over S$200! For purchases under S$200, conveniently pick up in-store.</p>
          </div>
        </div>
      </section>



      <section id="about" style={{ marginTop: '28px' }}>
        <div className="about-section">
          <div className="about-logo">
            <img src={logo} alt="Star Tidbits" style={{ width: 'auto', height: '200px' }} />
          </div>
          <div className="about-content">
            <h2>About Star Tidbits</h2>
            <p>Star Tidbits is Singapore's leading manufacturer of authentic Indian snacks, established in 1998. We operate both retail stores and wholesale distribution, serving customers across Singapore with traditional muruku, savories, peanuts, and Indian sweets made from authentic recipes.</p>
          </div>
        </div>
      </section>

      {/* Product Detail Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              {selectedProduct?.image ? (
                <img 
                  src={selectedProduct.image} 
                  alt={selectedProduct.name} 
                  style={{ width: '100%', height: '300px', objectFit: 'cover', borderRadius: '8px' }}
                />
              ) : (
                <div style={{ 
                  width: '100%', 
                  height: '300px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <span>No Image Available</span>
                </div>
              )}
            </div>
            <div className="col-md-6">
              <h4 style={{ color: 'var(--primary-saffron)', marginBottom: '1rem' }}>
                S${selectedProduct?.price?.toFixed(2) || '0.00'}
              </h4>
              <p style={{ marginBottom: '1rem' }}>
                <strong>Category:</strong> {selectedProduct?.category}
              </p>
              <p style={{ lineHeight: '1.6', marginBottom: '2rem' }}>
                {selectedProduct?.description || 'Premium quality snack made with authentic ingredients and traditional methods.'}
              </p>
              <div style={{ marginBottom: '1rem' }}>
                <span style={{ 
                  backgroundColor: selectedProduct?.stockStatus ? 'var(--accent-green)' : '#f44336',
                  color: 'white',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '20px',
                  fontSize: '0.875rem'
                }}>
                  {selectedProduct?.stockStatus ? 'In Stock' : 'Out of Stock'}
                </span>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button 
            variant="primary" 
            style={{ backgroundColor: 'var(--primary-saffron)', border: 'none', opacity: 0.6 }}
            disabled
          >
            Add to Cart
          </Button>
        </Modal.Footer>
      </Modal>
      </main>
    </div>
  );
};

export default Home;